import React, { useEffect, useState } from "react";
import { Field, useField, useFormikContext } from "formik";
import { Form } from "react-bootstrap";

import * as select from "tail.select";

import { useTranslation } from "react-i18next";
import "./SearchWithSelectField.scss";
import { useDispatch } from "react-redux";
import { hideLoading, showLoading } from "../../../reducers/app";

export default function SearchWithSelectField(props) {
  const { label, options, placeholder, onSearch, validationSchema, ...rest } =
    props;
  const [field, meta, helper] = useField(props);
  const { setValue } = helper;
  const { summaryMode, relatedField = null } = rest;
  const [search, setSearch] = useState(null);
  const [genericError, setGenericError] = useState(null);
  const { values, setStatus, getFieldProps } = useFormikContext();
  const fieldRefClass = "selectWithSearch-" + field.name;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { name } = getFieldProps(relatedField);
  const isRequired = validationSchema?.fields[field.name]?._exclusive?.required;
  const isError = (meta.touched && meta.error) || genericError;
  useEffect(() => {
    if (!relatedField) {
      console.error("NOT RELATED FIELD CONFIGURED!");
    }
    if (name !== relatedField) {
      return new Error(`RELATED FIELD NOT EXIST in [${fieldRefClass}]!`);
    }
    const _onChange = (item) => {
      const wrapper = item?.option?.parentNode?.nextSibling;
      if (wrapper && item.value) {
        wrapper.classList.remove("gcap-tail-select--no-selection");
      } else {
        wrapper.classList.add("gcap-tail-select--no-selection");
      }
      setValue(item.key);
    };
    // eslint-disable-next-line
    if (!summaryMode) {
      let SelectFieldObject = null;
      const actSelect = () => {
        try {
          SelectFieldObject = select("." + fieldRefClass, {
            classNames:
              "gcap-tail-select default gcap-tail-select--no-selection", // For our demonstration only
            descriptions: true,
            placeholder: placeholder,
            locale: "it",
          });
          if (SelectFieldObject) {
            SelectFieldObject.on("change", _onChange);
          }
        } catch (error) {
          console.log("Cannot rendered field" + fieldRefClass);
        }
      };
      actSelect();
      return () => {
        document.removeEventListener("DOMContentLoaded", actSelect);
      };
    }
    // eslint-disable-next-line
  }, [fieldRefClass, placeholder, name, relatedField]);
  const handleLoading = (value) => {
    if (value) {
      dispatch(showLoading());
    } else {
      dispatch(hideLoading());
    }
  };
  const getProperLabel = (field) => {
    let properLabel = field;
    if (typeof field === "object" && field.props && field.props.i18nKey) {
      properLabel = t(field.props.i18nKey);
    }
    return properLabel;
  };
  const setError = (value) => {
    setGenericError(value);
  };
  const handleSearch = () => {
    const nameForState = `${relatedField}-related-field`;
    if (onSearch) {
      const { name } = rest;
      const type = values[name];
      onSearch(
        name,
        type,
        nameForState,
        setStatus,
        search,
        setError,
        handleLoading
      );
    }
  };
  return (
    <Form.Group>
      {!summaryMode ? (
        <>
          <div>
            {label && (
              <Form.Label
                htmlFor={field.name}
                className="paragraph-small-fs9 font-color-1"
              >
                {label}
              </Form.Label>
            )}
          </div>
          <div>
            <div className="searchWithField__container">
              <div className="search-column">
                <div
                  className={`composedField ${genericError ? "is-invalid" : ""}`}
                >
                  <Form.Control
                    as="select"
                    className={`gcap-select ${fieldRefClass} ${
                      isError ? "is-invalid" : ""
                    }`}
                    {...field}
                    value={field.value}
                    onChange={(select) => console.log(select)}
                    id={field.name}
                    required={isRequired}
                  >
                    {(options || []).map((option) => {
                      let properLabel = option.label;
                      if (
                        typeof option.label === "object" &&
                        option.label.props &&
                        option.label.props.i18nKey
                      ) {
                        properLabel = t(option.label.props.i18nKey);
                      }
                      return (
                        <option
                          value={option.value}
                          key={field.name + "__" + option.value}
                        >
                          {properLabel}
                        </option>
                      );
                    })}
                  </Form.Control>
                  <span className="right-border-select" />
                  <Field
                    name={field.name + "-text"}
                    type={"text"}
                    autoComplete={"off"}
                    className={`form-control input-type-search ${
                      isError ? "is-invalid" : ""
                    }`}
                    placeholder={getProperLabel(placeholder)}
                    onChange={(e) => setSearch(e.target.value)}
                    aria-describedby={isError ? field.name + "-error" : null}
                    required={isRequired}
                    id={field.name + "-text"}
                  />
                </div>
              </div>
              <div className="search-btn-column">
                <button
                  disabled={!search}
                  className={
                    !search ? "btn btn-primary disabled" : "btn btn-primary"
                  }
                  type="button"
                  onClick={() => handleSearch()}
                >
                  {t("dashboard.manager.search-user.search-button")}
                </button>
              </div>
            </div>
            {meta.touched && meta.error && (
              <p
                className="form-error-text paragraph-small-form"
                role="alert"
                id={field.name + "-error"}
              >
                {meta.error}
              </p>
            )}
            {genericError && (
              <p
                className="form-error-text paragraph-small-form"
                role="alert"
                id={field.name + "-error"}
              >
                {getProperLabel(genericError)}
              </p>
            )}
          </div>
        </>
      ) : (
        <>
          {label && (
            <span className="paragraph-small-fs9">
              {label}
            </span>
          )}
        </>
      )}
    </Form.Group>
  );
}
